(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_description"] && !Shopify.designMode) return;
  try {
    const _fullDescription = document.querySelector('.bottle-info');
    const _read_more_button = document.querySelector('#read_more');
    const _scrollOffset = 90; // adjust this value to match your fixed header height

    if (_read_more_button && _fullDescription) {
      _read_more_button.addEventListener('click', (e) => {
        e.preventDefault();

        const elementTop = _fullDescription.getBoundingClientRect().top + window.pageYOffset;
        const scrollToPosition = Math.max(elementTop - _scrollOffset, 0);

        window.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
      });
    }
  } catch(e) { console.error(e); }
})();

})();
